import React from "react";
import {ResponsiveDialog} from "@hapinest/theme";
import {makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {useI18N} from "../../common/common";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(8),
        paddingBottom: theme.spacing(6)
    },
    textAlignCenter: {
        textAlign: "center"
    },
    mb3: {
        marginBottom: theme.spacing(3)
    },
    mtb1: {
        margin: theme.spacing(1, 0)
    },
}));

const InAppBrowserDialog = ({
    isOpen,
    handleClose,
}) => {
    const classes = useStyles();
    const {i18n} = useI18N();

    return (
        <ResponsiveDialog
            open={isOpen}
            handleClose={handleClose}
            hasCloseButton
            className={classes.container}
            content={
                <Grid
                    container
                    justify={"center"}
                    alignItems={"center"}
                    direction={"column"}
                >
                    <Grid
                        item
                        className={classes.mb3}
                    >
                        <img
                            src="/images/car_error.svg"
                            alt="cancel-booking-icon"
                            width={100}
                            height={100}
                        />
                    </Grid>

                    <Grid
                        item
                        className={clsx(classes.mb3, classes.textAlignCenter)}
                    >
                        <Typography variant={"h4"}>
                            {i18n("dialog.in_app_browser.title")}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        className={clsx(classes.mb3, classes.textAlignCenter)}
                    >
                        <Typography variant={"body1"}>
                            {i18n("dialog.in_app_browser.description")}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        className={clsx(classes.mb3, classes.textAlignCenter)}
                    >
                        <Typography variant={"body1"}>
                            {i18n("dialog.in_app_browser.action", {icon: (
                                <div key={"icon"}>
                                    <br/>

                                    <img
                                        src="/images/share_button.svg"
                                        alt="open-in-safari-icon"
                                        width={24}
                                        height={24}
                                        className={classes.mtb1}
                                    />

                                    <br/>
                                </div>
                            )})}
                        </Typography>
                    </Grid>
                </Grid>
            }
        />
    );
};

InAppBrowserDialog.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default InAppBrowserDialog;
